const usersApi = ({ apiClient }) => ({
  list(params) {
    return apiClient.get('users', {}, params)
  },
  show(id) {
    return apiClient.get(`users/${id}`)
  },
  store(payload = {}) {
    return apiClient.post('users', payload)
  },
  update(id, payload = {}) {
    return apiClient.put(`users/${id}`, payload)
  },
  destroy(id) {
    return apiClient.delete(`users/${id}`)
  },
  toggleActive(id) {
    return apiClient.patch(`users/${id}/toggle-active`)
  },
  roles() {
    return apiClient.get('users/roles')
  },
  realEstates() {
    return apiClient.get('users/real-estates')
  },
})
export default usersApi
